import { enumValidator } from '#validation/common/validators';
import { StorageCredentialsType } from '../constants';
export const storageCredentialsTypeValidator = enumValidator({
    values: StorageCredentialsType,
    invalidValueError: 'filespace.storageCredentialsType.invalid',
});
